export enum ComparisonType {
  HOTEL = 'Hotel',
}
